import { call, put, takeLatest } from 'redux-saga/effects';

import * as pricingActions from './pricingActions.js';
import { updatePricingApiCall } from './pricingApi.js';

function* updatePricingSaga({ payload }) {
  try {
    const { data } = yield call(updatePricingApiCall, payload);
    yield put(pricingActions.pricingUpdateStore(data));
  } catch (error) {
    yield put(pricingActions.pricingUpdateError(error.Message ? error.Message : error.toString()));
  }
}

export function* pricingWatcher() {
  yield takeLatest(pricingActions.pricingUpdateRequest.type, updatePricingSaga);
}
